// extracted by mini-css-extract-plugin
module.exports = {"contact":"contactForm-module--contact--23BZa","form":"contactForm-module--form--2iZ5-","info":"contactForm-module--info--1M8EC"};